// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../college-and-career-public/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nuxt-link-active[data-v-27578f54]{--border-opacity:1;border-color:#2c5282;border-color:rgba(44,82,130,var(--border-opacity))}", ""]);
// Exports
module.exports = exports;
